// @owners { team: patient-fulfillment }
import { createSelector } from 'reselect';
import getTransfers from './getTransfers';
import { type Transfer } from '~shared/types';

const getNewTransfers = createSelector([getTransfers], (transfers: Transfer[] = []) => {
  return transfers.filter((t) => t.status === 'new');
});

export default getNewTransfers;
